import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import consts from "../../constant";

const url = `${consts.BackendUrl}`;


interface otp {
    secret: string
}


export const generateTwoFactor = createAsyncThunk(
    "profile/generateTwoFactor", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userCreateTwoFactor`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Generate 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while generating 2fa.");
        }
    }
);

export const verifyTwoFactor = createAsyncThunk(
    "profile/verifyTwoFactor", // ✅ Unique action type under "profile"
    async (formData: otp, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userVerifyTwoFactor`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Verify 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while verifying 2fa.");
        }
    }
);


export const disableTwoFactor = createAsyncThunk(
    "profile/disableTwoFactor", // ✅ Unique action type under "profile"
    async (formData: otp, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userDisableTwoFactor`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Verify 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while disabling 2fa.");
        }
    }
);


export const generateEmailOtp = createAsyncThunk(
    "profile/generateEmailOtp", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userGenerateEmailOtp`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Generate 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while generating 2fa.");
        }
    }
);


export const userVerifyEamilOtp = createAsyncThunk(
    "profile/userVerifyEamilOtp", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userVerifyEamilOtp`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Generate 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while generating 2fa.");
        }
    }
);


export const userDisableEmailOtp = createAsyncThunk(
    "profile/userDisableEmailOtp", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userDisableEmailOtp`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Generate 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while generating 2fa.");
        }
    }
);


export const userDisableVerifyEmailOtp = createAsyncThunk(
    "profile/userDisableVerifyEmailOtp", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/userDisableVerifyEmailOtp`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Generate 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while generating 2fa.");
        }
    }
);

export const verifyTwofactorWithdraw = createAsyncThunk(
    "profile/verifyTwofactorWithdraw", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/verifyTwofactorWithdraw`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || " Otp verification failed!");
            }
            return rejectWithValue(" An unknown error occurred while verifying otp.");
        }
    }
);

export const verifyEmailOtpWithdraw = createAsyncThunk(
    "profile/verifyEmailOtpWithdraw", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/verifyEmailOtpWithdraw`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || " Otp verification failed!");
            }
            return rejectWithValue(" An unknown error occurred while verifying otp.");
        }
    }
);

export const verifyEamilGenrateOtpWithdraw = createAsyncThunk(
    "profile/verifyEamilGenrateOtpWithdraw", // ✅ Unique action type under "profile"
    async (formData: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/twofactor/verifyEamilGenrateOtpWithdraw`, formData, {
                // withCredentials: true,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                return rejectWithValue(error.response.data?.message || "Generate 2fa failed!");
            }
            return rejectWithValue("An unknown error occurred while generating 2fa.");
        }
    }
);



const twoFactorSlice = createSlice({
    name: "twoFactor",
    initialState: {
        authCode: "",
        authCodeUrl: "",
        twofa: null,
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(generateTwoFactor.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(generateTwoFactor.fulfilled, (state, action) => {
                state.isLoading = false;
                state.authCode = action.payload.result.secret;
                state.authCodeUrl = action.payload.result.otpauth_url + "&issuer=Crymadx_Exchange";
            })
            .addCase(generateTwoFactor.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })

            .addCase(verifyTwoFactor.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(verifyTwoFactor.fulfilled, (state, action) => {
                state.isLoading = false;
                state.twofa = action.payload
            })
            .addCase(verifyTwoFactor.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })

            .addCase(disableTwoFactor.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(disableTwoFactor.fulfilled, (state, action) => {
                state.isLoading = false;
                state.twofa = action.payload
            })
            .addCase(disableTwoFactor.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as any;
            })
    },
});


export default twoFactorSlice.reducer;
